// extracted by mini-css-extract-plugin
export default {"zoomConfigContent":"ZoomConfigsSection__zoomConfigContent-Cn9TZ"};